import { Callout, DelayedRender, DirectionalHint, FocusTrapZone, IconButton, Stack, Text } from "@fluentui/react";
import { useId } from '@fluentui/react-hooks';
import { appStyles } from "global/Application";
import { useRef, useState } from "react";



interface IInformationCalloutProps {
    children: JSX.Element;
    hover?: boolean;
    postText?: string;
    directionalHint?: DirectionalHint;
    calloutClassName?: string;
}


const InformationCallout: React.FunctionComponent<IInformationCalloutProps> = (props) => {

    const calloutTimer = useRef<NodeJS.Timeout | null>(null);

    const [isCalloutVisible, setIsCalloutVisible] = useState(false);
    const buttonId = useId('callout-button');

    return <>
        <Stack horizontal>

            <IconButton
                id={buttonId}
                iconProps={{ iconName: "Info" }}
                styles={{
                    root: {
                        height: 'auto',
                        width: 'auto',
                    },
                    icon: {
                        fontSize: '12px',
                        root: {
                            height: 'auto',
                            width: 'auto',
                        },
                    },
                }}
                onClick={() => {
                    setIsCalloutVisible(true);
                }}
                onMouseEnter={() => {
                    if (props.hover)
                        setIsCalloutVisible(true);
                }}
                onMouseLeave={() => {
                    if (props.hover)
                        calloutTimer.current = setTimeout(() => {
                            setIsCalloutVisible(false);
                        }, 300);
                }}
            />
            {props.postText &&
                <Text variant="small">
                    {props.postText}
                </Text>
            }
        </Stack>

        {isCalloutVisible && (
            <Callout
                // className={styles.callout}
                className={props.calloutClassName ?? appStyles.callout}
                target={`#${buttonId}`}
                onDismiss={() => setIsCalloutVisible(false)}
                role="alert"
                onMouseEnter={() => {
                    if (props.hover)
                        if (calloutTimer.current)
                            clearTimeout(calloutTimer.current)
                }}
                onMouseLeave={() => setIsCalloutVisible(false)}
                directionalHint={props.directionalHint}
            >
                <DelayedRender>
                    <FocusTrapZone>
                        {props.children}
                    </FocusTrapZone>
                </DelayedRender>
            </Callout>
        )}
    </>
}
export default InformationCallout;